import React, { Component, useState } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { applyDataTable } from "../../../../custom/dataTable";
import $ from "jquery";
import withRouter from "../../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../../_helpers/endpointService"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { CssTextField, CssTextFieldLast } from "../../../../custom/textField"
import { faker } from '@faker-js/faker';

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
        padding: "5px 10px"
    },
    fontIcon: {
        paddingRight: "8px",
    }
}));

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

let data
let labels = {}
let options

//const HSEQKPI = () => {
class HSEQKPI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isbinded: false,
            isMobile: false,
            ProjectId: 0,
            isAccess: false,
            UserRole: "",
            scroll: false,
            addData: []
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const { ProjectId } = this.state;
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isAccess: true }) : this.setState({ isAccess: false })
        this.state.ProjectId = parseInt(localStorage.getItem("DashId"))
        this.state.UserRole = localStorage.getItem("UserRoles");
        applyDataTable("staffTable");
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
        this.setState({}, () => {
            this.getkpiinfo(this.state.ProjectId)
        })
    }

    getkpiinfo = (data) => {
        let apiUrl = API.GET_KPI + '/projectId?projectId=' + data
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "get",
            url: apiUrl
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.addData = response.data

                }
                this.setState({}, () => {
                    this.bindData(this.state.addData);
                })
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    }

    bindData = (bindData) => {
        options = {
            scales: {
                y: {
                    ticks: {
                        stepSize: 1,
                        beginAtZero: true,
                    },
                },
            },
            indexAxis: 'x',
            elements: {
                bar: {
                    borderWidth: 1,
                    padding: 5
                },
            },
            responsive: true,
            plugins: {
                legend: {
                    position: 'bottom',
                    margin: 20
                },
                datalabels: {
                    display: false,
                },
            }
        };
        let _NearMissActual = [];
        let _NearMissExpected = [];
        let _IncidentActual = [];
        let _IncidentExpected = [];
        var temp = [];
        bindData.map((i, ind) => {
            var item = i.Kpi;
            temp.push(item);
        })
        labels = temp;
        labels.map((i, ind) => {
            var temp = bindData.filter(x => x.Kpi == i)
            _NearMissActual.push(temp[0].NearMissActual)
            _NearMissExpected.push(temp[0].NearMissExpected)
            _IncidentActual.push(temp[0].IncidentActual)
            _IncidentExpected.push(temp[0].IncidentExpected)
        })
        if (labels.length > 24) {
            this.state.scroll = true;
        } else {
            this.state.scroll = false;
        }

        data = {
            labels,
            datasets: [{
                label: 'Near Miss-Expected',
                data: _NearMissExpected,
                borderColor: '#ADD8E6',
                backgroundColor: '#ADD8E6',
            },
            {
                label: 'Near Miss-Actual',
                data: _NearMissActual,
                borderColor: '#000080',
                backgroundColor: '#000080',
            },
            {
                label: 'Incident-Expected',
                data: _IncidentExpected,
                borderColor: '#F8ABAB',
                backgroundColor: '#F8ABAB',
            },
            {
                label: 'Incident-Actual',
                data: _IncidentActual,
                borderColor: '#E10000',
                backgroundColor: '#E10000',
            },
            ],
        };
        this.state.isbinded = true;
    }

    handleInputChange = (e, type, index) => {
        const { addData } = this.state;
        if (type === 'NearMissExpected') {
            addData.map((i, ind) => {
                if (index === ind) {
                    i.NearMissExpected = e.target.value ? parseInt(e.target.value) : "";
                }
            })
        }
        if (type === 'IncidentExpected') {
            addData.map((i, ind) => {
                if (index === ind) {
                    i.IncidentExpected = e.target.value ? parseInt(e.target.value) : ""
                }
            })
        }
        this.setState({}, () => {
            this.bindData(addData);
        })
    }

    handleInput = (index) => {
        const { addData } = this.state
        addData.map((i, ind) => {
            if (index === ind) {
                data = {
                    "ProjectId": i.ProjectId,
                    "HseqKPIId": i.HseqKPIId,
                    "Kpi": i.Kpi,
                    "Comments": i.Comments,
                    "NearMissExpected": i.NearMissExpected,
                    "NearMissActual": i.NearMissActual,
                    "IncidentExpected": i.IncidentExpected,
                    "IncidentActual": i.IncidentActual,
                    "ModifiedDate": i.ModifiedDate,
                    "ModifiedBy": i.ModifiedBy
                }
            }
        })
        this.updateData(data)
    }

    updateData = (data) => {
        const { addData } = this.state;
        let apiUrl = API.PUT_KPI + data.HseqKPIId;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                } else {
                }
                this.getkpiinfo(this.state.ProjectId)
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#KPI1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Hseqkpi1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Hseqkpi").addClass("d-none");
        $("#Hseqkpi").removeClass("d-block");
        $("#KPIL").removeClass("active-color");
        $("#KPIT").removeClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#KPI1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Hseqkpi1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Hseqkpi").removeClass("d-none");
        $("#Hseqkpi").addClass("d-block");
        $("#KPIL").addClass("active-color");
        $("#KPIT").addClass("fw-bolder");
    }

    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    render() {
        let { classes, menuToggle } = this.props;
        const { addData, UserRole } = this.state
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"KPI" + "1"} className=' textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="KPI" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>KPI</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto border-top" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-12 pt-2">
                                {this.state.isMobile ? <></> : <h6>KPI</h6>}
                            </div>
                        </div>

                        {/* <div className="col-7.6 col-sm-7.6 col-lg-7.6 col-xl-7.6 col-md-7.6"> */}
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div style={{ width: "100%" }} className=" table-responsive">
                                <table className=" mt-2 table border-left text-center" >
                                    <thead>
                                        <tr>
                                            <th className="border-top border-right border-left align-middle Nowrap" width="150px" style={{ minWidth: '150px', maxWidth: '150px' }}><span className="spandoc-thead">Series</span></th>
                                            {addData && addData.map((i, ind) => (
                                                <th className="border-top border-right border-left align-middle Nowrap" width="70px" style={{ minWidth: '70px', maxWidth: '70px' }}><span className="spandoc-thead">{i.Kpi}</span></th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th className="border-right align-middle spanTopBar">Near Miss - Expected</th>
                                            {addData && addData.map((i, ind) => (
                                                UserRole === "Admin" || UserRole === "Supervisor" ?
                                                    <td className="border-right border-left spandoc-td">
                                                        <CssTextField
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            id="text01"
                                                            value={i.NearMissExpected}
                                                            type="number"
                                                            onChange={(e) => this.handleInputChange(e, 'NearMissExpected', ind)}
                                                            onBlur={(e) => this.handleInput(ind)}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }}
                                                        />
                                                    </td>
                                                    :
                                                    <td className="border-right border-left spandoc-td">
                                                        <CssTextField
                                                            disabled={true}
                                                            multiline
                                                            fullWidth
                                                            id="text01"
                                                            variant="outlined"
                                                            value={i.NearMissExpected}
                                                            type="number"
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }}
                                                        />
                                                    </td>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th className="border-right align-middle spanTopBar">Near Miss - Actual</th>
                                            {addData && addData.map((i, ind) => (
                                                <td className="border-right border-left spandoc-td">
                                                    <CssTextField
                                                        disabled={true}
                                                        multiline
                                                        fullWidth
                                                        id="text01"
                                                        variant="outlined"
                                                        value={i.NearMissActual}
                                                        type="number"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }} />
                                                </td>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th className="border-right align-middle spanTopBar">Incident - Expected</th>
                                            {addData && addData.map((i, ind) => (
                                                UserRole === "Admin" || UserRole === "Supervisor" ?
                                                    <td className="border-right border-left spandoc-td">
                                                        <CssTextField
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            id="text01"
                                                            value={i.IncidentExpected}
                                                            type="number"
                                                            onChange={(e) => this.handleInputChange(e, 'IncidentExpected', ind)}
                                                            onBlur={(e) => this.handleInput(ind)}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />
                                                    </td>
                                                    :
                                                    <td className="border-right border-left spandoc-td">
                                                        <CssTextField
                                                            disabled={true}
                                                            multiline
                                                            fullWidth
                                                            id="text01"
                                                            variant="outlined"
                                                            value={i.IncidentExpected}
                                                            type="number"
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />
                                                    </td>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th className="border-right align-middle spanTopBar">Incident - Actual</th>
                                            {addData && addData.map((i, ind) => (
                                                <td className="border-right border-left spandoc-td">
                                                    <CssTextField
                                                        disabled={true}
                                                        multiline
                                                        fullWidth
                                                        id="text01"
                                                        variant="outlined"
                                                        value={i.IncidentActual}
                                                        type="number"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }} />
                                                </td>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive mb-5">
                                <h6>HSEQ Performance - Indicator</h6>
                                <div class="chartWrapper" style={window.innerWidth < 1000 || this.state.scroll == true ? { overflowX: "scroll" } : { overflowX: "hidden" }}>
                                    {this.state.isbinded ?
                                        <div className="chartAreaWrapper" style={window.innerWidth < 1000 || this.state.scroll == true ? {} : { width: "100%" }}>
                                            <Bar options={options} className="col-sm-7.6 col-7.6 col-lg-7.6 col-xl-7.6 col-md-7.6 overflow-hidden" data={data} height={50}/>
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle
    };
}

HSEQKPI.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HSEQKPI))
);

